import { Box, Flex, Heading, Image, List, Text, chakra, ListItem, ListIcon, Button } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconOrangeCircle } from 'assets/icons';

interface IUpsaleTemplate {
  heading: string;
  description: string;
  learnMoreLink: string;
  upgradeLink: string;
  featureList: string[];
  heroImg: string;
  isColumn?: boolean;
}

const UpsaleTemplate: React.FC<IUpsaleTemplate> = ({
  heading,
  description,
  learnMoreLink,
  upgradeLink,
  featureList,
  heroImg,
  isColumn = false,
}) => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  return (
    <Flex
      gridGap="16"
      flexDir={{ base: isColumn ? 'row' : 'column', md: isColumn ? 'column' : 'row' }}
      justifyContent="space-evenly"
      alignItems="center"
      pl="20"
      pt="14"
    >
      <Box w="100%">
        <Heading as="h2" fontSize="2xl" fontWeight="semibold" mb="3">
          {heading}
        </Heading>
        <Text fontSize="sm" color="gray.500" mb="8">
          {description}{' '}
          <chakra.span textDecor="underline" color="secondary.500" fontWeight="semibold">
            <a href={learnMoreLink} target="_blank" rel="noreferrer">
              {t('common:learnMore')}
            </a>
          </chakra.span>
        </Text>
        <List spacing={3} mb="14">
          {featureList?.map((item: string, index: number) => (
            <ListItem key={index}>
              <Flex alignItems="center">
                <ListIcon as={IconOrangeCircle} w="8px" h="8px" />
                {item}
              </Flex>
            </ListItem>
          ))}
        </List>
        <Flex gridGap="4">
          <Button colorScheme="secondary" onClick={() => navigate(upgradeLink)}>
            {t('common:upgradeToPro')}
          </Button>
          <a href={learnMoreLink} target="_blank" rel="noreferrer">
            <Button colorScheme="secondary" variant="ghost">
              {t('common:learnMoreAboutPlans')}
            </Button>
          </a>
        </Flex>
      </Box>
      <Box w="100%">
        <Image src={heroImg} alt="Hero image" />
      </Box>
    </Flex>
  );
};

export default UpsaleTemplate;
